import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import sortBy from 'lodash/sortBy';

let currentSearchAmenities = {};

export const initialReservationTypes = {
    all: {
        slug: 'all',
        name: 'All Parking Options',
    },
    // eslint-disable-next-line quote-props
    '247': {
        slug: '247',
        name: '24/7 Regular Parking',
        description: 'Unlimited parking 7 days a week, 24 hours a day.',
        count: 0,
        related: [],
        active: false,
    },
    // eslint-disable-next-line camelcase
    daytime_only: {
        slug: 'daytime_only',
        name: 'Daytime Only Parking',
        description:
            'Great option if you drive to work but don’t need to park overnight.',
        count: 0,
        related: ['daytime_and_247_weekend', '247'],
        active: false,
    },
    // eslint-disable-next-line camelcase
    daytime_and_247_weekend: {
        slug: 'daytime_and_247_weekend',
        name: 'Daytime + 24/7 Weekend Parking',
        description:
            'Great option if you drive to work during the week and need unlimited parking during the weekend.',
        count: 0,
        related: ['247'],
        active: false,
    },
    // eslint-disable-next-line camelcase
    nights_only: {
        slug: 'nights_only',
        name: 'Nights Only Parking',
        description:
            'Great  option if you need to park overnight, but use your car during the day.',
        count: 0,
        related: ['nights_and_247_weekend', '247'],
        active: false,
    },
    // eslint-disable-next-line camelcase
    nights_and_247_weekend: {
        slug: 'nights_and_247_weekend',
        name: 'Nights + 24/7 Weekend Parking',
        description:
            'Great option if you need to park overnight and throughout the weekend.',
        count: 0,
        related: ['247'],
        active: false,
    },
    storage: {
        slug: 'storage',
        name: 'Storage',
        description:
            'Safe and secure storage if you want to drop off your car for an extended period of time',
        count: 0,
        related: [],
        active: false,
    },
    valet: {
        slug: 'valet',
        name: 'On-Demand Valet',
        description:
            'Book through SpotHero and and a third party valet will pick up/drop off your car at your desired location. Restrictions apply.',
        count: 0,
        related: [],
        active: false,
    },
};

/* V2-CLEANUP
Delete this setAmenities function when Search V2 Integration is complete.
setAmenitiesV2 can be renamed to setAmenities.
This is used on Search for Transient, Monthly, and Event verticals
*/
export const setAmenities = ({
    spots,
    isNewSearch,
    rateType = 'hourly_rates',
}) => {
    const amenitiesKey =
        rateType === 'monthly_rates' ? 'amenities_full' : 'amenities';

    if (isNewSearch) {
        currentSearchAmenities = {};
    } else {
        // reset amenity counts
        forEach(currentSearchAmenities, amenity => {
            amenity.count = 0;
        });
    }

    // populate amenities
    forEach(spots, spot => {
        const spotAmenities = [];

        forEach(spot[rateType], rate => {
            forEach(rate[amenitiesKey], ({slug, name, sort_order: order}) => {
                if (spotAmenities.indexOf(slug) < 0) {
                    if (isUndefined(currentSearchAmenities[slug])) {
                        currentSearchAmenities[slug] = {
                            slug,
                            name,
                            ...(order && {order}),
                            count: 1,
                        };
                    } else {
                        currentSearchAmenities[slug].count++;
                    }

                    spotAmenities.push(slug);
                }
            });
        });
    });

    // sort all of the amenities based on the order from the BE
    const sorted = sortBy(currentSearchAmenities, ['order']);
    const sortedAmenities = {};

    // repopulate an object for consumption downstream with the sorted amenities
    forEach(sorted, item => {
        sortedAmenities[item.slug] = item;
    });

    return sortedAmenities;
};

// this takes in a list of spots and the currently filtered spots and
// returns an object of amenities and counts
export const setAmenitiesV2 = ({spots, filteredSpots}) => {
    const aggregatedSearchAmenities = {};

    // builds object of amenities
    spots.forEach(spot => {
        const rate = spot.selectedRate;

        if (rate) {
            rate.amenities.forEach(
                ({type: slug, displayName: name, sortOrder: order}) => {
                    if (isUndefined(aggregatedSearchAmenities[slug])) {
                        aggregatedSearchAmenities[slug] = {
                            slug,
                            name,
                            ...(order && {order}), // is this necessary and does it change per spot?
                            totalCount: 1,
                            count: 0,
                        };
                    } else {
                        aggregatedSearchAmenities[slug].totalCount++;
                    }
                }
            );
        }
    });

    // updates the filteredCount based on current filtered spots
    filteredSpots.forEach(spot => {
        const rate = spot.selectedRate;

        if (rate) {
            rate.amenities.forEach(({type: slug, displayName: name}) => {
                // assume that all filteredSpots have amenities that we have already seen
                if (aggregatedSearchAmenities[slug]) {
                    aggregatedSearchAmenities[slug].count++;
                }
            });
        }
    });

    // sort all of the amenities based on the order from the BE
    const sorted = sortBy(aggregatedSearchAmenities, ['order']);
    const sortedAmenities = {};

    // repopulate an object for consumption downstream with the sorted amenities
    forEach(sorted, item => {
        sortedAmenities[item.slug] = item;
    });

    return sortedAmenities;
};

export const setReservationTypes = ({spots, reservationTypes}) => {
    // reset all reservation types to inactive
    forEach(reservationTypes, reservationType => {
        if (reservationType.slug !== 'all') {
            reservationType.active = false;
        }
    });

    // populate reservation types
    forEach(spots, spot => {
        forEach(spot.monthly_rates, rate => {
            if (rate.reservation_type !== 'all') {
                if (!isUndefined(reservationTypes[rate.reservation_type])) {
                    reservationTypes[rate.reservation_type].active = true;
                }
            }
        });
    });

    return reservationTypes;
};
